<template>
  <div v-if="totalPages > 1" class="cytomine-pagination">
    <b-pagination
      :total="total"
      :current="normalizedCurrent"
      :per-page="perPage"
      :size="size"
      :order="order"
      :icon-prev="iconPrev"
      :icon-next="iconNext"
      @change="changePage"
    />
    <label class="page-selector">
      <span>{{ $t('page') }}</span>
      <span class="select" :class="size">
        <select
          data-testid="pagination-page-select"
          :aria-label="$t('page')"
          :value="normalizedCurrent"
          @change="changePage(Number($event.target.value))"
        >
          <option v-for="page in totalPages" :key="page" :value="page">{{ page }}</option>
        </select>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CytominePagination',
  props: {
    total: {type: Number, default: 0},
    current: {type: Number, default: 1},
    perPage: {type: Number, default: 20},
    size: {type: String, default: 'is-small'},
    order: {type: String, default: 'is-centered'},
    iconPrev: {type: String, default: 'chevron-left'},
    iconNext: {type: String, default: 'chevron-right'}
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage));
    },
    normalizedCurrent() {
      return Math.min(Math.max(this.current, 1), this.totalPages);
    }
  },
  watch: {
    totalPages() {
      if (this.current !== this.normalizedCurrent) {
        this.changePage(this.normalizedCurrent);
      }
    }
  },
  methods: {
    changePage(page) {
      const nextPage = Math.min(Math.max(Number(page), 1), this.totalPages);
      this.$emit('update:current', nextPage);
      this.$emit('change', nextPage);
    }
  }
};
</script>

<style scoped lang="scss">
.cytomine-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.cytomine-pagination ::v-deep .pagination {
  margin: 0;
}

.page-selector {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
}
</style>
